import { MantineThemeOverride } from '@mantine/core';

export type MarkTheme = NonNullable<MantineThemeOverride['components']>['Mark'];

export const Mark: MarkTheme = {
  // todo: define
};
